<div
  data-private
  class="smartdoc-styles"
  [ngStyle]="{
    'margin-top': topOffset ? topOffset.toString() + 'px' : '0px',
    'margin-bottom': bottomOffset ? bottomOffset.toString() + 'px' : '0px'
  }"
  [innerHTML]="packageDoc?.packageDocumentImageString | safeHtml"
></div>
